import { useEffect, useState } from 'react';

// Dark-mode toggle (#44) — flips html.dark; the skin lives in darkTheme.css.
// Preference persists per device; default follows the OS.
export function ThemeToggle({ className = '' }: { className?: string }) {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'));

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  return (
    <button
      onClick={() => setDark(d => !d)}
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`flex items-center justify-center h-9 w-9 rounded-full text-gray-400 hover:text-[#C77D3F] transition-colors ${className}`}
    >
      <span className="material-symbols-outlined text-xl">{dark ? 'light_mode' : 'dark_mode'}</span>
    </button>
  );
}
